/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { AddressResource, SearchQueryParams, PageQueryParams, AfterKeyPageQueryParams } from '../apiCommon.typings';
import { CashBoxesStatus } from '../cashBoxes/cashBoxesClient.typings';
import { ServiceOperatorDto, storeStatus, StoreType } from '../stores/storesClientTypings';

export const TAXATION_TYPES = ['VAT', 'PROFIT', 'SIMPLIFIED', 'INCOME'] as const;
export type TaxationType = (typeof TAXATION_TYPES)[number];

interface CompanyCashboxesStat {
    count: number;
    online: number;
    offline: number;
    registration: number;
    blocked: number;
    total: number;
}

interface StoreCashboxesStat {
    count: number;
    online: number;
    offline: number;
    invalid_time: number;
    total: number;
}

export interface CompanyDto {
    taxNumber: string;
    cashBoxes: CompanyCashboxesStat;
    storeTypes: StoreType[];
    name: string;
    storesCount: number;
    status: companiesStatus;
    taxAuthority: string;
    taxationTypes: string[];
}

export interface CompanyDetailsDto {
    taxNumber: string;
    name: string;
    activity?: string[];
    stores_count: number; //TODO not used, remove?
    legal_address: AddressResource; //TODO not used, remove?
    fullAddress: string;
    registration_date: string;
    serviceOperators: ServiceOperatorDto[];
    taxAuthority: string;
    taxationTypes: string[];
    taxpayerType: 'PHYSICAL' | 'LEGAL';
    status: companiesStatus;
}

export interface CompanyStore {
    tax_number: string;
    name: string;
    activity?: string;
    address: AddressResource;
    fullAddress: string;
    cashboxes: StoreCashboxesStat;
    status: storeStatus;
}

export interface CompanyStoresListDto {
    count: number;
    list: CompanyStore[];
}

export interface CompaniesListDto {
    afterKey?: string;
    companies: CompanyDto[];
}

export const COMPANIES_STATUSES = ['ACTIVE', 'SUSPENDED', 'CLOSED'] as const;

export type companiesStatus = (typeof COMPANIES_STATUSES)[number];

export interface CompaniesListFilterParams extends Partial<SearchQueryParams> {
    statuses?: companiesStatus[];
    fromCashBoxesCount?: number | string;
    toCashBoxesCount?: number | string;
    fromStoresCount?: number | string;
    toStoresCount?: number | string;
    taxAuthorityIds?: number[];
    taxationTypes?: TaxationType[];
    storeTypes?: StoreType[];
}

export type CompaniesListRequestParams = CompaniesListFilterParams & AfterKeyPageQueryParams;
export type CompaniesListExcelRequestParams = CompaniesListFilterParams;

export type CompanyStoresListQueryParams = CompanyStoresListFilterParams & PageQueryParams;

export interface CompanyStoresListFilterParams {
    status?: storeStatus[];
}

export interface CashboxesByTaxNumbersQueryParams {
    cashBoxTaxNumbers?: string[];
    deviceFactoryNumbers?: string[];
    operatorTaxNumbers?: string[];
    eliminated?: boolean;
    limit: number;
}

export type CashboxesByTaxNumbersDto = {
    afterKeyTaxNumber: string;
    cashBoxes: CashboxesByTaxNumbersItemDto[];
};

export type CashboxesByTaxNumbersItemDto = {
    taxNumber: string;
    status: CashBoxesStatus;
    temporary: boolean;
    companyTaxNumber: string;
    companyName: string;
    storeTaxNumber: string;
    storeName: string;
    cashRegisterFactoryNumber: string;
    deviceFactoryNumber: string;
};
